import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import Button from "../../components/Button/Button";

const RestaurantHero = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.25,
  });

  return (
    <section className="w-full min-h-[90vh] bg-white pt-8" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 flex flex-col-reverse lg:flex-row items-center gap-12">
        
        {/* Left Content */}
        <div className="flex-1 text-center lg:text-left">
          <motion.span
            initial={{ opacity: 0, y: -10 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5 }}
            className="inline-block bg-purple-100 text-purple-700 text-xs font-semibold px-3 py-1 rounded-full mb-4"
          >
            Zola For Restaurant
          </motion.span>

          <motion.h1
            initial={{ y: -40, opacity: 0 }}
            animate={inView ? { y: 0, opacity: 1 } : {}}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6 leading-tight"
          >
            Enhancing Guest <br /> and Partner <br /> Relationship in the <br /> Restaurant Industry
          </motion.h1>

          <motion.p
            initial={{ y: 20, opacity: 0 }}
            animate={inView ? { y: 0, opacity: 1 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-gray-600 mb-8 max-w-md mx-auto lg:mx-0"
          >
            Zola’s Guest Experience Platform captures feedback from diners at every touchpoint.
            With multi-channel tools, every visit becomes an opportunity to delight.
          </motion.p>

          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={inView ? { y: 0, opacity: 1 } : {}}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="flex justify-center lg:justify-start gap-4"
          >
              <Button variant="primary">Get started</Button>
            <Button variant="secondary" calendly>Book a demo</Button>
          </motion.div>
        </div>

        {/* Right Image */}
        <motion.div
          initial={{ scale: 0.95, opacity: 0 }}
          animate={inView ? { scale: 1, opacity: 1 } : {}}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="flex-1"
        >
          <img
            src="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f6486eb37afacd89a100db_happy-waiter-serving-food-group-cheerful-friends-pub%201.png" 
            alt="Waiter serving food"
            className="w-full h-[80vh] rounded-lg shadow-lg object-cover"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default RestaurantHero;
